import React from "react";
import { TextField, TextAreaField } from "../inputs";

export default function GenericFields() {
  return (
    <>
      <div className="form-row">
        <div className="form-item">
          <TextField label="First Name" name="data[first_name]" required />
        </div>

        <div className="form-item">
          <TextField label="Last Name" name="data[last_name]" required />
        </div>
      </div>

      <div className="form-row">
        <div className="form-item">
          <TextField type="date" label="Date of Birth" name="data[date_of_birth]" required />
        </div>

        <div className="form-item">
          <TextField label="Student ID" name="data[student_id]" required />
        </div>
      </div>

      <TextAreaField label="Address" name="data[address]" required />
      
      <div className="form-row">
        <div className="form-item">
          <TextField label="City" name="data[city]" required />
        </div>

        <div className="form-item">
          <TextField label="State" name="data[state]" required />
        </div>

        <div className="form-item">
          <TextField label="ZIP" name="data[zip]" required />
        </div>
      </div>
    </>
  );
}
